import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { SearchPipe } from './common/search.pipe';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppNavBarComponent } from './app-nav-bar/app-nav-bar.component';
import { AppLoginComponent } from './app-login/app-login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './profile/profile.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { AppShipmentFormComponent } from './app-shipment-form/app-shipment-form.component';
import { SharedModule } from './shared/shared.module';
import { FormFieldLocationComponent } from './shared/dhl-form/components/form-field-location/form-field-location.component';
import { AppSwitchUserComponent } from './app-switch-user/app-switch-user.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { TrainingDocumentUploadComponent } from './training-document-upload/training-document-upload.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AppStaticPageModule } from './app-static-page/app-static-page.module'
import { ConvertUomPipe } from './common/convert-uom.pipe';
import { JsonEditorComponent } from 'ang-jsoneditor' 
import { SchemaValidationComponent } from './schema_validation/schema-validation/schema-validation.component';


// create our cost var with the information about the format that we want

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY'
  },
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({ declarations: [
        AppComponent,
        AppNavBarComponent,
        AppLoginComponent,
        DashboardComponent,
        ProfileComponent,
        AppShipmentFormComponent,
        AppSwitchUserComponent,
        ContactUsComponent,
        TrainingDocumentUploadComponent,
        SearchPipe,
        SchemaValidationComponent
    ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        JsonEditorComponent,
        SharedModule,
        AppRoutingModule,
    	NgxSliderModule,
        BrowserAnimationsModule,
        NgxDaterangepickerMd.forRoot(),
        AppStaticPageModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
        ConvertUomPipe,
        // Material 17+ draws a checkmark indicator on selected toggles; hide it to match the pre-upgrade look.
        {
            provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
            useValue: { hideSingleSelectionIndicator: true, hideMultipleSelectionIndicator: true }
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule {
}
